import React from "react";

import { useParams } from "react-router";

import { useQuery } from "@apollo/client";

import LiveDataMap from "./livedata-map";

import panelCollectionMapQuery from "./panel-collection-map-query";

interface Props {
  // nodes?: any[];
  // panelCollectionName: String;
}

function PanelCollectionMapContainer(props: Props) {
  // const {
  //   // nodes,
  //   panelCollectionName
  // } = props;
  const { panelCollectionName } = useParams<any>();
  // const n = nodes ? nodes.join(",") : undefined;
  const { data, error: metaError, loading: metaLoading } = useQuery(
    panelCollectionMapQuery,
    {
      variables: {
        panelCollectionName: panelCollectionName,
        // node: n,
      },
    }
  );
  if (metaLoading) {
    return <div>Loading...</div>;
  }
  if (metaError) {
    console.error(metaError.message);
    return <div>Error! {metaError.message}</div>;
  }
  return <LiveDataMap bounds={data.map.bounds} items={data.map.items} />;
}

export default PanelCollectionMapContainer;
